import { RowNode } from '@ag-grid-community/core';

const MIN_CONFIDENCE = -1;

type ConfidenceSource = { confidence?: number | null } | null | undefined;

type RowDataWithAiResult = {
  ai_result?: {
    confidence?: number | null;
  } | null;
};

const resolveConfidence = (value: ConfidenceSource, node?: RowNode | null): number => {
  const valueConfidence = value && typeof value === 'object' ? value.confidence : undefined;
  const nodeData = node?.data as RowDataWithAiResult | undefined;
  const nodeConfidence = nodeData?.ai_result?.confidence;

  const candidate = valueConfidence ?? nodeConfidence;
  return typeof candidate === 'number' && Number.isFinite(candidate) ? candidate : MIN_CONFIDENCE;
};

export const compareAiConfidence = (
  valueA: ConfidenceSource,
  valueB: ConfidenceSource,
  nodeA?: RowNode | null,
  nodeB?: RowNode | null,
): number => {
  const confidenceA = resolveConfidence(valueA, nodeA);
  const confidenceB = resolveConfidence(valueB, nodeB);

  return confidenceA - confidenceB;
};
